import React, { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { Button, Modal, Spin } from 'antd';
import ReactVisibilitySensor from 'react-visibility-sensor';

import Electronic from '../../../components/AgreementContent/Electronic';
import Regulation from '../../../components/AgreementContent/Regulation';

import { CloseIcon } from '../../../assets/icons';

import useLegal from '../../../Hooks/useLegal';
import { resetPolicyDetails } from '../../../store/reducer/legalSlice';
import { createMarkup } from '../../../utils/createMarkup';
import { POLICY_AGREEMENTS, POLICY_ENUMS } from '../../../utils/policy.constants';

const AgreementModal = ({
  title,
  closeModal,
  isModalOpen,
  activeAgreement,
  loading,
  handleScrolltoBottom,
  listInnerRef,
  activeAgreeButton,
  agreementData,
  handleAgreeAndContinue,
  policyName,
}) => {
  const dispatch = useDispatch();

  const [content, setContent] = useState(false);

  const { fetchPolicyByEnum, isFetchingPolicy, policyDetails } = useLegal({ shouldFetchTypes: false });

  useEffect(() => {
    if (POLICY_ENUMS.includes(policyName)) {
      fetchPolicyByEnum(policyName);
    } else {
      setContent(true);
    }

    return () => {
      dispatch(resetPolicyDetails());
      setContent(false);
    };
  }, [policyName]);

  return (
    <Modal
      title={title}
      open={isModalOpen}
      onOk={closeModal}
      onCancel={closeModal}
      destroyOnClose={true}
      width={652}
      closeIcon={<CloseIcon color='#1A1519' />}
      footer={
        <div className='agreement__modal__footer'>
          <p className='agreement-number'>
            {activeAgreement + 1} of {agreementData.length}
          </p>
          <Button
            type='primary'
            className='ant-btn-primary--alt'
            loading={loading}
            onClick={() => handleAgreeAndContinue()}
            disabled={!activeAgreeButton.includes(activeAgreement)}
          >
            Agree and continue
          </Button>
        </div>
      }
      className='agreement__modal ant-modal--both'
      centered
    >
      <div ref={listInnerRef} id='content' className='agreement__modal__content'>
        {POLICY_ENUMS.includes(policyName) ? (
          <Spin spinning={isFetchingPolicy} className='agreement__spin'>
            <div dangerouslySetInnerHTML={createMarkup(policyDetails?.content)} />
          </Spin>
        ) : (
          <>
            {policyName === POLICY_AGREEMENTS.EFTA && <Electronic key={'policy3'} />}
            {policyName === POLICY_AGREEMENTS.DISCLOSURE && <Regulation key={'policy4'} />}
          </>
        )}

        {policyName && (content || policyDetails?.content) && (
          <ReactVisibilitySensor key={activeAgreement} onChange={(value) => handleScrolltoBottom(value, activeAgreement)}>
            <div className='agreement__modal__dot'>.</div>
          </ReactVisibilitySensor>
        )}
      </div>
    </Modal>
  );
};

export default AgreementModal;
